import { GET_UNITS, GET_UNITS_SUCCESS, GET_UNITS_FAILURE } from "./actionTypes";

const initialState = {
  units: [],
  loading: false,
  error: "",
};

const brands = (state = initialState, action) => {
  switch (action.type) {
    case GET_UNITS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_UNITS_SUCCESS:
      state = {
        ...state,
        loading: false,
        units: action.payload.units,
      };
      break;
    case GET_UNITS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default brands;
